import { ControlValueOption } from "app/shared/model";

export interface IGetExternalDataResponse {
    Success: string;
    Result: object[];
    Message?: string;
}

export class GetExternalDataResponse {
    Success: string;
    Result: object[];
    Message?: string;

    constructor(data?: IGetExternalDataResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Success = _data["Success"];
            let res = [];
            if (_data["Result"]) {
                _data["Result"].forEach((r: any) => {
                    res.push(r);
                });
            }
            if (_data["Message"]) {
                this.Message = _data["Message"];
            }

            this.Result = res;
        }
    }

    static fromJS(data: any): GetExternalDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetExternalDataResponse();
        result.init(data);
        return result;
    }
}

export class SearchCloudDataResponse implements ISearchCloudDataResponse {
    /** Gets or sets total count. */
    totalCount!: number;
    /** Gets or sets items */
    items!: SearchCloudDataItem[];

    constructor(data?: ISearchCloudDataResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["total_count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as SearchCloudDataItem[];
                for (let item of _data["items"])
                    this.items!.push(SearchCloudDataItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchCloudDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCloudDataResponse();
        result.init(data);
        return result;
    }
}

export interface ISearchCloudDataResponse {
    /** Gets or sets total count. */
    totalCount: number;
    /** Gets or sets items */
    items: SearchCloudDataItem[];
}

export class SearchCloudDataItem implements ISearchCloudDataItem
{
    id!: string | undefined;
    text!: string | undefined;

    constructor(data?: ISearchCloudDataItem) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SearchCloudDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCloudDataItem();
        result.init(data);
        return result;
    }
}


export interface ISearchCloudDataItem { 
    id: string | undefined;
    text: string | undefined;
}

export interface IGetControlOptionsResponse {
    success: boolean;
    result: ControlValueOption[];
    message?: string;
}

export class GetControlOptionsResponse implements IGetControlOptionsResponse {
    success: boolean;
    result: ControlValueOption[];
    message?: string;

    constructor(data?: IGetControlOptionsResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            if (Array.isArray(_data["Result"])) {
                this.result = [] as ControlValueOption[];
                for (let item of _data["Result"]){
                    this.result!.push(ControlValueOption.fromJS(item));
                }
            }
            if (_data["Message"]) {
                this.message = _data["Message"];
            }
        }
    }

    static fromJS(data: any): GetControlOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetControlOptionsResponse();
        result.init(data);
        return result;
    }
}

export const EXTERNAL_DATASET_UPDATED_MESSAGE = 'ExternalDatasetUpdated';
